<script lang="ts">
	import '../DstPushNotifications/DstPushNotifications.webcomponent.svelte';

	import { loginState } from '@derstandard/login-state';
	import { onMount } from 'svelte';

	/**
	 *
	 */
	function initCleverPush() {
		window.CleverPush = window.CleverPush || [];
	}

	onMount(async () => {
		initCleverPush();
	});

	loginState.subscribe(({ payload }) => {
		initCleverPush();

		if (payload.mId) {
			window.CleverPush.push(['setAttribute', 'user_id', payload.mId]);
		}
	});
</script>

<!--
	During development the CleverPush modal is often in the way. It can be disabled by setting the `VITE_CLEVERPUSH_ENABLE`
	environment variable. We should probably find a more general solution for this that also works for our users.
-->
{#if import.meta.env.VITE_CLEVERPUSH_ENABLE === 'true'}
	<dst-push-notifications />
{/if}
